import Router from './router';
import Store from '@/store/';
import routes from './routes';
import _ from 'lodash';
import Permission from '../utils/Permission';
import { reqFetchIsSupportWechat } from '../api/user';
import { Message as ElMessage } from 'element-ui';

Router.beforeEach(async (to, from, next) => {
  if (process.env.VUE_APP_SUPPORT_USER_SYSTEM === 'T') {
    if (Permission.isLogin()) {
      // 将用户 token 进行缓存
      if (!Store.state.user.token) {
        Store.commit('user/STORE_TOKEN', Permission.getUserToken());
      }
      // 将用户信息进行缓存
      if (!Store.getters['user/userId']) {
        Store.commit('user/STORE_USER_INFO', Permission.getUserInfo());
      }
      // 判断企业微信是否可用
      if (process.env.VUE_APP_SUPPORT_WORK_WECHAT === 'T') {
        if (!Store.state.user.isInitedSupportWorkWechat) {
          try {
            const { data } = await reqFetchIsSupportWechat();
            Store.commit('user/STORE_IS_WORK_WECHAT_ENABLED', data);
            Store.commit('user/STORE_IS_INITED_SUPPORT_WORK_WECHAT', true);
          } catch (e) {
            ElMessage({ message: '企业微信功能初始化失败，请尝试刷新页面', type: 'error' });
          }
        }
      }
    } else {
      Permission.login();
    }
  }

  if (!Store.state.page.isSidebarMenuItemsSaved) {
    const sidebarRoutes = routes.filter(route => route.meta && route.meta.inMenu);
    Store.commit('page/STORE_SIDEBAR_MENU_ITEMS', sidebarRoutes);
  }

  /**
   * 设置页面标题
   */
  const routeTitle = (document.title =
    _(to.matched)
      .map(item => _.get(item, 'meta.title'))
      .compact()
      .last() || '');

  document.title = routeTitle ? `日志服务平台 - ${routeTitle}` : '日志服务平台';

  next();
});

Router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default Router;
